export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9828.6978e481.jpg";